import { Link } from "react-router-dom";
import { studentWorkspacePaths } from "@/utils/student-workspace";

export function ReportBreadcrumbs({ currentPage, studentId }: { currentPage: string; studentId: string }): JSX.Element {
  return (
    <nav aria-label="面包屑" className="mb-3 text-sm text-slate-500">
      <ol className="flex flex-wrap items-center gap-2">
        <li>
          <Link
            to={studentWorkspacePaths.reports(studentId)}
            className="font-medium text-brand hover:text-brand-dark hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/40"
          >
            报告
          </Link>
        </li>
        <li aria-hidden="true" className="text-slate-300">
          /
        </li>
        <li aria-current="page" className="font-medium text-slate-700">
          {currentPage}
        </li>
      </ol>
    </nav>
  );
}
